import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';


function HomeContent() {
  return (
    <div className='home-content'>
        <div className="container">
          <div className="col-md-8 col-sm-10">
            <div className="head">
              <h2>Search Between More <br/> Than <span className='headspan'>50,000</span> Open Jobs.</h2>
              <p>Trending Jobs Keywords: 
                <span className='web'><button href="#">Driver</button></span>
                <span className='web'><button href="#">Delivery</button></span>
                <span className='web'><button href="#">Copper Brazing</button></span>
                <span className='web'><button href="#">Bus Driver</button></span>
              </p>
            </div>
            <form action="">
              <fieldset className='fieldset'>
                <div className='col-md-4 col-sm-3'>
                  <input type="text" className="form-control brdr" placeholder="Search for jobs..." />
                </div>
                <div className="col-md-3 col-sm-3 select-container">
                  <span className="icon"></span>
                  <select className="form-control brdr">
                    <option value="" disabled selected>Location</option>
                    <option value="Australia">Australia</option>
                    <option value="Brazil">Brazil</option>
                    <option value="Canada">Canada</option>
                    <option value="China">China</option>
                    <option value="France">France</option>
                    <option value="Germany">Germany</option>
                    <option value="India">India</option>
                    <option value="Italy">Italy</option>
                    <option value="Japan">Japan</option>
                    <option value="Mexico">Mexico</option>
                    <option value="UK">United Kingdom</option>
                    <option value="USA">United States</option>
                  </select>
                </div>
                <div className="col-md-3 col-sm-3 select-container">
                  <span className="icon"></span> 
                  <select className="form-control brdr">
                    <option value="" disabled selected>Category</option>
                    <option value="web-design">Web Design</option>
                    <option value="development">Development</option>
                    <option value="marketing">Marketing</option>
                    <option value="sales">Sales</option>
                    <option value="support">Support</option>
                    <option value="management">Management</option>
                  </select>
                </div>
                <div className="col-md-2 col-sm-3 padd-0 m-clear">
                  <Link to="/job-details#job-section" className='srch-btn1'>Search</Link>
                </div>
              </fieldset>
            </form>
          </div>
        </div>
    </div>
  )
}

export default HomeContent
